<div id="websitePageEditorWrapper">
  <!-- Loading Indicator -->
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

  <!-- Edit Mode (Single Mode) -->
  <div cdkDropListGroup id="websiteEditorContent">
    <blocks-wrapper
      *ngIf="!this.mobile"
      cdkDropList
      id="sidebarMain"
      cdkDropListSortingDisabled>
    </blocks-wrapper>

    <div id="websitePreviewWrapper">
      <div id="mainWebsitePreviewShape">
        <div class="websitePreview" id="mainWebsitePreview" [ngClass]="{'template5Layout': isTemplate5Active(), 'template6Layout': isTemplate6Active()}">
          <!-- Above-Navbar Announcement Bar (outside draggable area, rendered before header) -->
          <div *ngFor="let blockData of blockDataService.blocksData">
            <div
              *ngIf="blockData.type === 'announcementBar' && blockData.data?.position === 'above-navbar'"
              class="stacksBlockContainer"
              [id]="'blockid' + blockData.id">
              <block-announcement-bar
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-announcement-bar>
            </div>
          </div>

          <!-- Static Header (outside draggable area) -->
          <div *ngFor="let blockData of blockDataService.blocksData">
            <div
              *ngIf="blockData.type === 'header'"
              class="stacksBlockContainer headerBlockContainer"
              >
              <block-header
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap blockHeader"
                [id]="'blockid' + blockData.id">
              </block-header>
            </div>
          </div>

          <!-- Draggable Content Area (excludes header and footer) -->
          <section
            id="mobileMain"
            class="openedBlocks websiteBlocks"
            cdkDropList
            [cdkDropListAutoScrollStep]="10"
            [cdkDropListSortingDisabled]="false"
            [cdkDropListConnectedTo]="getColumnsIds()"
            (cdkDropListDropped)="drop($event)">
            <div
              *ngFor="let blockData of getDraggableBlocks(); let i = index; trackBy: trackByBlockId"
              class="stacksBlockContainer"
              [id]="'blockid' + blockData.id"
              cdkDrag
              [cdkDragBoundary]="'.websitePreview'"
              [cdkDragLockAxis]="'y'"
              [cdkDragData]="blockData">
              <block-image
                *ngIf="blockData.type == 'image'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-image>
              <block-static
                *ngIf="blockData.type == 'static'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap blockStatic">
              </block-static>
              <block-text
                *ngIf="blockData.type == 'text'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-text>
              <block-products
                *ngIf="blockData.type == 'products'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-products>
              <block-categories
                *ngIf="blockData.type == 'categories'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-categories>
              <stacks-products
                *ngIf="blockData.type == 'stacksProducts'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </stacks-products>
              <stacks-categories
                *ngIf="blockData.type == 'stacksCategories'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </stacks-categories>
              <block-posts
                *ngIf="blockData.type == 'posts'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-posts>
              <block-slider
                *ngIf="blockData.type == 'slider'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-slider>
              <block-video
                *ngIf="blockData.type == 'video'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-video>
              <block-button
                *ngIf="blockData.type == 'button'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-button>
              <block-floating-social
                *ngIf="blockData.type == 'floatingSocial'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-floating-social>
              <block-section
                *ngIf="blockData.type == 'section'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-section>
              <block-reviews
                *ngIf="blockData.type == 'reviews'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-reviews>
              <block-announcement-bar
                *ngIf="blockData.type == 'announcementBar'"
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap">
              </block-announcement-bar>
            </div>
          </section>

          <!-- Static Footer (outside draggable area) -->
          <div *ngFor="let blockData of blockDataService.blocksData">
            <div
              *ngIf="blockData.type === 'footer'"
              class="stacksBlockContainer"
              [id]="'blockid' + blockData.id">
              <block-footer
                [importedBlockData]="blockData"
                [builderType]="'website'"
                class="blockWrap blockFooter">
              </block-footer>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Blocks Toggle -->
    <blocks-wrapper
      [ngClass]="builderService.blocksCollapsed ? 'collapsedParentBlocks' : 'openedParentBlocks'"
      *ngIf="this.mobile"
      cdkDropList
      cdkDropListSortingDisabled>
    </blocks-wrapper>
    <button
      mat-icon-button
      (click)="blocksHome()"
      class="blocksHomeMobile"
      [ngClass]="builderService.blocksCollapsed ? '' : 'openedButton'"
      *ngIf="mobile">
      <mat-icon class="material-icons material-icons-outlined">grid_view</mat-icon>
    </button>
  </div>

</div>
 <!-- Settings Panel -->
  <div id="settingsTemplatesWrapper" [ngClass]="openSettings ? 'openedSettings' : 'closedSettings'">
    <div *ngIf="mobile" class="closeSettings" (click)="closeSettings()">
      <mat-icon>close</mat-icon>
    </div>
    <block-settings [builderType]="'website'" id="blockSettings"></block-settings>
  </div>
